import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import React from "react";
import styles from "./FindingButtons.module.sass";
import { SovosButton } from "mosaic-react";

const ShowAllFindingsButton = (props) => {
    const {
        hideDetailButton = true,
        projectId,
        fiscalYear,
        importId,
        ruleId,
        modulePrefix,
        alignStart = false,
        findingsAmount,
    } = props;
    const { pushDialog, getFindingDetails, i18n } = useGlobalValue();

    return (
        <div
            className={`${alignStart ? styles["finding-buttons-start"] : styles["finding-buttons"]}`}
        >
            {hideDetailButton || ruleId === "0" ? null : (
                <div className={`${styles["finding-button"]}`}>
                    <SovosButton
                        variant="text"
                        onClick={() => {
                            pushDialog &&
                                pushDialog("ConfirmDialog", i18n`Rule Execution`, {
                                    title: i18n`Do you want to see all findings for this rule?`,
                                    promptText: i18n`Please confirm that you want to proceed!`,
                                }).then(() => {
                                    getFindingDetails(
                                        projectId,
                                        fiscalYear,
                                        modulePrefix,
                                        ruleId,
                                        importId,
                                    ).then((res) => res && window.location.reload());
                                });
                        }}
                    >
                        {i18n`view_all_findings`} ({findingsAmount})
                    </SovosButton>
                </div>
            )}
        </div>
    );
};

export default ShowAllFindingsButton;
